import { queryOptions } from '@tanstack/react-query';
import { listSigningKeysServerFn } from '@/server/functions/signing-keys';

export const signingKeysQueryOptions = (orgSlug: string) =>
  queryOptions({
    queryKey: ['signing-keys', orgSlug],
    queryFn: () => listSigningKeysServerFn({ data: { orgSlug } }),
  });
